var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3195 5.15625C13.499 5.15625 12.7121 5.4822 12.1319 6.06239L6.06239 12.1319C5.4822 12.7121 5.15625 13.499 5.15625 14.3195V29.6805C5.15625 30.501 5.4822 31.2879 6.06239 31.8681L12.1319 37.9376C12.7121 38.5178 13.499 38.8438 14.3195 38.8438H29.6805C30.501 38.8438 31.2879 38.5178 31.8681 37.9376L37.9376 31.8681C38.5178 31.2879 38.8438 30.501 38.8438 29.6805V14.3195C38.8438 13.499 38.5178 12.7121 37.9376 12.1319L31.8681 6.06239C31.2879 5.4822 30.501 5.15625 29.6805 5.15625H14.3195ZM22 11.6875C22.9492 11.6875 23.7188 12.457 23.7188 13.4062V23.7188C23.7188 24.668 22.9492 25.4375 22 25.4375C21.0508 25.4375 20.2812 24.668 20.2812 23.7188V13.4062C20.2812 12.457 21.0508 11.6875 22 11.6875ZM24.0625 29.9062C24.0625 31.0453 23.1391 31.9688 22 31.9688C20.8609 31.9688 19.9375 31.0453 19.9375 29.9062C19.9375 28.7672 20.8609 27.8438 22 27.8438C23.1391 27.8438 24.0625 28.7672 24.0625 29.9062Z",
    fill: "#2BA168"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.bb37bdf4da08be743d8fb9bea65fe30a.svg";
export { ForwardRef as ReactComponent };